import React from 'react';
import { partners } from '../../mockData';

const PartnerLogos = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Our Partner Ecosystem
          </h2>
          <p className="text-lg text-gray-600">
            Bringing together the best of our partner network to create competitive advantage
          </p>
        </div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 flex items-center justify-center border border-gray-200 hover:border-indigo-300 hover:shadow-md transition-all duration-300"
            >
              <img
                src={`/images/partners/${partner.logo}.png`}
                alt={partner.name}
                className="h-10 w-auto object-contain grayscale hover:grayscale-0 transition duration-300"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PartnerLogos;
